import { Button, ContentCard, Div, Banner, ButtonGroup, RichCell, IconButton, Card } from '@vkontakte/vkui';
import React from 'react';
import { useAppContext } from '../../../AppContext';
import PropTypes from 'prop-types';
import { UserAvatar } from '../../components/UserAvatar';
import { Icon20WriteOutline } from '@vkontakte/icons';


export const InviteBlockComponent = ({eventId, eventImage, eventName, eventInviteCode, eventInviteLink, buttonLabel, settingsButtonLabel, settingsButtonOnClick, scanReceiptsListLabel, scanReceiptsListButtonOnClick}) => {
  const context = useAppContext();

  if (context.store.isEnabledScanReceipt) {
    return (<Div className="EventImage">
      <Card>
        <RichCell
          before={<UserAvatar src={eventImage} size={96} name={eventName} id={eventId} />}
          after={
            <RichCell.Icon aria-label={settingsButtonLabel} onClick={settingsButtonOnClick}>
              <Icon20WriteOutline />
            </RichCell.Icon>
          }
          actions={
            <ButtonGroup mode="horizontal" gap="s" stretched align={'right'}>
              <Button
                mode="outline"
                onClick={scanReceiptsListButtonOnClick}
              >
                {scanReceiptsListLabel}
              </Button>
              <Button
                className="EventInvite_copyButton"
                onClick={() => context.getBridge().shareInvite(eventId, eventInviteCode, eventInviteLink, context)}
              >
                {buttonLabel}
              </Button>
            </ButtonGroup>
          }
        >
          {eventName}
        </RichCell>
      </Card>
    </Div>);
  }

  return (<Div className="EventImage">
    <Banner
      before={
        <UserAvatar src={eventImage} size={96} name={eventName} id={eventId} />
      }
      header={eventName}
      actions={<div style={{ textAlign: 'right' }}>
        <ButtonGroup mode="vertical" gap="s" align={'right'}>
          <Button
            className="EventInvite_copyButton"
            onClick={() => context.getBridge().shareInvite(eventId, eventInviteCode, eventInviteLink, context)}
          >
            {buttonLabel}
          </Button>
          <Button mode="link" onClick={settingsButtonOnClick}>{settingsButtonLabel}</Button>
        </ButtonGroup>
      </div>
      }
    />
  </Div>);
}

InviteBlockComponent.propTypes = {
  eventId: PropTypes.number.isRequired,
  eventImage: PropTypes.string,
  eventName: PropTypes.string.isRequired,
  eventInviteCode: PropTypes.string.isRequired,
  eventInviteLink: PropTypes.string.isRequired,
  buttonLabel: PropTypes.string.isRequired,
  settingsButtonLabel: PropTypes.string.isRequired,
  settingsButtonOnClick: PropTypes.func.isRequired,
  scanReceiptsListLabel: PropTypes.string.isRequired,
  scanReceiptsListButtonOnClick: PropTypes.func.isRequired,
}
